import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { UserSession } from '../models/user-session';

@Injectable({
  providedIn: 'root'
})
export class UserStorageService {
  storageKey: string = 'currentUserSession';
  _currentUserSession?: UserSession;
  constructor() {
  }

  get currentUserSession(): UserSession | undefined {
    if (!this._currentUserSession) {
      this._currentUserSession = this.loadCurrentUserSession();
    }
    return this._currentUserSession;
  }

  set currentUserSession(userSession: UserSession | undefined) {
    this._currentUserSession = userSession;
    if (this._currentUserSession){
      this.saveCurrentUserSession(this._currentUserSession);
    } else {
      this.deleteCurrentUserSession();
    }
  }

  get currentUser(): User | undefined {
    return this.currentUserSession?.user;
  }

  set currentUser(user: User | undefined) {
    if (this._currentUserSession && user){
      this._currentUserSession.user = user;
      this.saveCurrentUserSession(this._currentUserSession);
    }
  }

  get accessToken(): string | undefined {
      return this.currentUserSession?.accessToken;
  }

  private loadCurrentUserSession(): UserSession | undefined {
    try {
      const currentUserStorage = localStorage.getItem(this.storageKey);
      if (currentUserStorage) {
        const userSession = JSON.parse(currentUserStorage);
        return <UserSession>userSession;
      }
    } catch (e) {
      // Ignore
    }
    return;
  }

  private saveCurrentUserSession(userSession: UserSession): void {
    localStorage.setItem(this.storageKey, JSON.stringify(userSession));
  }

  private deleteCurrentUserSession() {
    localStorage.removeItem(this.storageKey);
  }

  logOut(): void {
    // remove userSEssion from local storage to log user out
    this.deleteCurrentUserSession();
  }

  isCurrentUserValid(): boolean {
    if (this.currentUserSession) {
      if (!this.currentUserSession.accessTokenExpires) {
        return true;
      }

      const currentDate = new Date();
      const expirationDate = this.currentUserSession.accessTokenExpires;

      return (expirationDate > currentDate);
    }

    return false;
  }
}
